import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Grid, Box, Typography, makeStyles } from "@material-ui/core";
const useStyles = makeStyles(theme => ({
    bold: {
        fontWeight: "bold"
    }
}));
export function ListCell(props) {
    const { rowData, columns } = props;
    const classes = useStyles(props);
    return (_jsx(_Fragment, { children: columns.map((col, i) => {
            return (_jsxs(Grid, { item: true, container: true, xs: 12, children: [_jsx(Box, { flex: "1 1 auto", children: _jsx(Typography, { className: classes.bold, children: col.title }) }), _jsx(Box, { flex: "1 1 auto", textAlign: "right", children: columns[i].render ? (columns[i].render(rowData)) : (_jsx(Typography, { children: rowData[columns[i].field] })) })] }, i));
        }) }));
}
//# sourceMappingURL=ListCell.js.map